const CHANGES_MADE = 'CHANGES_MADE';
const RESET_CHANGES = 'RESET_CHANGES';

export { CHANGES_MADE, RESET_CHANGES };
